import React, { Component } from 'react';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Container, TextField, Typography, Button, CssBaseline, Box, Avatar } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
    };
  }

  renderLogIn = () => {
    const { username } = this.state;
    const { t } = this.props;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t('authScreenTranslations:FORGOT_PASS')}?
          </Typography>

          <Box sx={{ mt: 1 }}>
            <Typography sx={{ mt: 2, mb: 2 }} textAlign="center">
              {t('authScreenTranslations:ENTER_UN_TO_RESET_PASS')}
            </Typography>
            <TextField
              sx={{ mb: 2 }}
              margin="normal"
              fullWidth
              name="username"
              label={t('authScreenTranslations:USERNAME')}
              value={username}
              onChange={e => this.setState({ username: e.target.value })}
            />

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 1, mb: 2 }}
              onClick={() => this.props.history.push('/confirmcode', { isChangePassword: true })}
            >
              {t('authScreenTranslations:RESET_MY_PASS')}
            </Button>
          </Box>
        </Box>
      </Container>
    );
  };

  render() {
    const { location, auth } = this.props;
    const { loggedIn } = auth;

    return loggedIn ? (
      <Redirect to={{ pathname: '/', state: { from: location } }} />
    ) : (
      this.renderLogIn()
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const cForgotPassword = connect(mapStateToProps, {})(ForgotPassword);
const tForgotPassword = withTranslation(['authScreenTranslations'])(cForgotPassword);

export { tForgotPassword as ForgotPassword };
